var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.364 8.17 15.83 3.636a5.529 5.529 0 0 0-4.167-1.612l-5 .239a4.6 4.6 0 0 0-4.4 4.4l-.239 5.006a5.537 5.537 0 0 0 1.612 4.161l4.534 4.534a5.527 5.527 0 0 0 7.809 0l4.385-4.385a5.526 5.526 0 0 0 0-7.809zM19.3 14.918 14.918 19.3a4.027 4.027 0 0 1-5.688 0L4.7 14.77a4.041 4.041 0 0 1-1.174-3.035l.239-5.006A3.108 3.108 0 0 1 6.73 3.761l5-.239A4.026 4.026 0 0 1 14.77 4.7l4.53 4.53a4.027 4.027 0 0 1 0 5.688zM9.5 6.25a3.25 3.25 0 1 0 3.25 3.25A3.254 3.254 0 0 0 9.5 6.25zm0 5a1.75 1.75 0 1 1 1.75-1.75 1.752 1.752 0 0 1-1.75 1.75z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m17.53 13.53-4 4a.75.75 0 0 1-1.06-1.06l4-4a.75.75 0 0 1 1.06 1.06z",
    opacity: 1,
    "data-original": "#fdaa29",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.009c6d83a762aa93b27ea12c9e5c36d1.svg";
export { ForwardRef as ReactComponent };